import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getEventTemplates,
  getImages,
  getTemplateLocations,
  moveMarkers,
  saveEvent,
  setActiveMarker,
  setBackgroundImage,
  setCenter,
  setStartTime,
  signOut,
  toggleOverlay,
  updateMarker,
  setImageCarousel,
} from "../actions";
import useWindowDimensions from "./commons/WindowDimensions";
import SaveEvent from "./event/SaveEventOverlay";
import EventDrawer from "./leftDrawer";
import Map from "./Map";
import MarkerOverlay from "./markers/MarkerOverlay";
import NavBar from "./navbar";
import Snack from "./Snackbar";
import TicketModal from "./tickets";

import Tutorial from "./Tutorial";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://seek-city.com">
        SeekCity
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  relative: {
    position: "relative",
  },
  keyboardBackButton: {
    position: "absolute",
    zIndex: 200,
    left: 10,
    top: 10,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    background: "#749474",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(1),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  inputs: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

const Dashboard = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [userOpen, setUserOpen] = useState(false);
  const [modalIsopen, setModalOpen] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);
  const [markerOverlay, setMarkerOverlay] = useState(false);
  const [saveEventOpen, setSaveEventOpen] = useState(false);
  const { height } = useWindowDimensions();

  useEffect(() => {
    props.getEventTemplates();
  }, []);

  return (
    <div className={classes.root}>
      <TicketModal
        modalIsopen={modalIsopen}
        setModalOpen={setModalOpen}
        template={props.template}
      />
      <SaveEvent
        saveEventOpen={saveEventOpen}
        setSaveEventOpen={setSaveEventOpen}
        saveEvent={props.saveEvent}
        template={props.template}
        locations={props.locations}
        placeholders={props.placeholders}
      />
      <CssBaseline />
      <Snack />
      <Tutorial open={showTutorial} close={() => setShowTutorial(false)} />
      <NavBar
        setOpen={setOpen}
        open={open}
        userOpen={userOpen}
        setUserOpen={setUserOpen}
        moveMarkers={() => props.moveMarkers(props.center)}
        saveEvent={() => setSaveEventOpen(true)}
      />
      <EventDrawer
        eventId={_.get(props, "template.id")}
        userOpen={userOpen}
        setFinalizeModal={setModalOpen}
        setUserOpen={setUserOpen}
        setShowTutorial={setShowTutorial}
        open={open}
        setOpen={setOpen}
      />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <MarkerOverlay
            markerOverlayOpen={markerOverlay}
            setMarkerOverlay={setMarkerOverlay}
          />
          <Grid container spacing={3}>
            <Grid item xs={12}>
                <Paper
                  className={classes.paper}
                  style={{ height: height * 0.7 }}
                >
                  <Map
                    moveMarkers={props.moveMarkers}
                    locations={props.locations}
                    updateMarker={props.updateMarker}
                    setCenter={props.setCenter}
                    center={props.center}
                    placeholders={props.placeholders}
                    setActiveMarker={props.setActiveMarker}
                    template={props.template}
                    isAdmin={props.isAdmin}
                    setBackgroundImage={props.setBackgroundImage}
                  />
                </Paper>
            </Grid>
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
};

const mapStateToProps = ({ events, auth }) => {
  const {
    locations,
    loading,
    center,
    template,
    placeholders,
    showImageCarousel,
  } = events;
  const { isAdmin } = auth;

  return {
    locations,
    loading,
    center,
    template,
    isAdmin,
    placeholders,
    showImageCarousel,
  };
};

export default connect(mapStateToProps, {
  getEventTemplates,
  getTemplateLocations,
  updateMarker,
  moveMarkers,
  setCenter,
  toggleOverlay,
  setActiveMarker,
  saveEvent,
  setStartTime,
  setBackgroundImage,
  signOut,
  setImageCarousel,
  getImages,
})(Dashboard);
